"use client"
import Image from "next/image"
import { PopupLayout } from "@/components/common/popup/layout/PopupLayout"

interface BookshelfAnalysisProcessingPopupProps {
  onConfirm: () => void
}

const BookshelfAnalysisProcessingPopup = ({
  onConfirm,
}: BookshelfAnalysisProcessingPopupProps) => {
  return (
    <PopupLayout buttons={[{ title: "확인", onClick: onConfirm }]}>
      <div className="flex flex-col items-center gap-6">
        <div className="relative flex h-24 w-24 flex-shrink-0 items-center justify-center">
          <Image
            src="/images/illustrations/shoot_book_list_01.webp"
            alt="책장 촬영 처리 중 일러스트레이션"
            width={96}
            height={96}
            className="object-contain"
          />
        </div>

        <p className="typo-rl-body2 text-rl-gray-font-caption max-w-xs text-center font-normal sm:max-w-sm">
          촬영한 책장의 도서 정보를 확인하는데
          <br />
          시간이 소요될 수 있습니다.
          <br />
          확인이 완료되면 메시지로 알려드릴게요.
        </p>
      </div>
    </PopupLayout>
  )
}

export default BookshelfAnalysisProcessingPopup
